module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/path-to-regexp/~/isarray/index.js
// module id = 1083
// module chunks = 2 4 5 10 11 15